import { ArrowDownIcon, SearchIcon, SmartphoneIcon, WrenchIcon } from 'lucide-react';
const diagnosticItems = [{
  number: '01',
  title: 'HACE TIEMPO QUE NO HACÉS ESA CONEXIÓN',
  description: 'Conocés los componentes, pero necesitás repasar cómo va el circuito.'
}, {
  number: '02',
  title: 'PERDÉS TIEMPO BUSCANDO UNA RESPUESTA',
  description: 'Abrís videos, grupos y apuntes, pero justo el esquema que necesitás no aparece.'
}, {
  number: '03',
  title: 'QUERÉS REVISAR ALGO ANTES DE TERMINAR',
  description: 'Tenés una duda puntual y preferís consultar antes de dar el trabajo por cerrado.'
}];
const solutionSteps = [{
  number: '01',
  icon: SearchIcon,
  title: 'BUSCÁ EN LA APP',
  description: 'Encontrá instalaciones por tema o utilizá el asistente para orientarte.'
}, {
  number: '02',
  icon: SmartphoneIcon,
  title: 'CONSULTÁ EL ESQUEMA',
  description: 'Revisá la lámina visual, su explicación y los puntos de atención.'
}, {
  number: '03',
  icon: WrenchIcon,
  title: 'SEGUÍ CON TU TRABAJO',
  description: 'Aplicá tus conocimientos con una referencia organizada a mano.'
}];
export function ProblemSolutionSection() {
  return <section className="overflow-hidden bg-[#07101f] text-white" aria-labelledby="diagnostic-title" data-id="element-93" data-mp="tlal5xtt87kk">
      <div className="mx-auto max-w-5xl px-5 pb-16 pt-16 sm:px-8 md:pb-24 md:pt-24" style={{
      paddingTop: "11px",
      paddingBottom: "6px"
    }} data-id="element-94" data-mp="17kjp9z4qrb86">
        <div className="max-w-3xl" data-id="element-95" data-mp="1hhoe66pz1kso">
          <div className="flex items-center gap-3 text-[#EF3035]" data-id="element-96" data-mp="1hgn3428ygyay">
            <span className="h-px w-10 bg-[#EF3035]" aria-hidden="true" data-id="element-97" data-mp="1cj4u6buxuj2y" />
            <p className="text-[10px] font-black tracking-[0.16em]" data-id="element-98" data-mp="1ch0obodhba01">DIAGNÓSTICO DE CAMPO</p>
          </div>
          <h2 id="diagnostic-title" className="mt-5 max-w-3xl text-3xl font-black leading-[0.98] tracking-[-0.04em] text-white sm:text-5xl" data-id="element-99" data-mp="1m8oab9r9nyu4">
            SABÉS HACER EL TRABAJO. PERO NO SIEMPRE TENÉS CADA CONEXIÓN EN LA CABEZA.
          </h2>
        </div>

        <div className="mt-12 border-y border-[#EF3035]/35" data-id="element-100" data-mp="1vanw0fd87r3e">
          {diagnosticItems.map((item, index) => <article key={item.number} data-reveal className={`technical-reveal technical-reveal-delay-${index + 1} grid grid-cols-[58px_1fr] gap-4 py-7 sm:grid-cols-[110px_1fr] sm:gap-8 sm:py-10 ${index > 0 ? 'border-t border-[#EF3035]/25' : ''}`} data-id="element-101" data-mp="sxhubehu8fzi" data-mpi={index}>
              <span className="font-black leading-none tracking-[-0.06em] text-[#EF3035] text-5xl sm:text-7xl" data-id="element-102" data-mp="16n35w3tb5sxi">{item.number}</span>
              <div className="border-l border-[#EF3035]/70 pl-4 sm:pl-6" data-id="element-103" data-mp="1bld2miuol1l8">
                <h3 className="max-w-xl text-sm font-black leading-tight tracking-wide text-white sm:text-xl" data-id="element-104" data-mp="1gkzqrnc1s28t">{item.title}</h3>
                <p className="mt-2 max-w-lg text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-105" data-mp="1llncpulf5sw6">{item.description}</p>
              </div>
            </article>)}
        </div>
      </div>

      <div id="solution" className="relative border-t border-[#F5C844]/35" style={{
      background: 'linear-gradient(180deg, #0B1F3B 0%, #0B1F3B 46%, #19366B 64%, #DCE6EF 84%, #F4F7FA 100%)'
    }} aria-labelledby="solution-title" data-id="element-106" data-mp="3ncqs0x697vn2">
        <div className="absolute left-1/2 top-0 h-12 w-px -translate-x-1/2 bg-[#F5C844]" aria-hidden="true" data-id="element-107" data-mp="3jvmbw1kaark4" />
        <div className="mx-auto max-w-5xl px-5 pb-16 pt-20 sm:px-8 md:pb-24 md:pt-28" style={{
        paddingTop: "47px",
        paddingBottom: "0px",
        paddingLeft: "0px",
        paddingRight: "0px"
      }} data-id="element-108" data-mp="3f189hf77fk5y">
          <div className="mx-auto max-w-2xl text-center" style={{
          paddingTop: "1px"
        }} data-id="element-109" data-mp="6nj688wnwk1u">
            <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-full border border-[#F5C844] bg-[#0B1F3B] text-[#F5C844]" data-id="element-110" data-mp="1oevvey04g9x">
              <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="3tqwaefbh4gt5" />
            </div>
            <p className="mt-5 text-[10px] font-black tracking-[0.16em] text-[#F5C844]" data-id="element-112" data-mp="3os2xop40gtu1">BIBLIOTECA DE CONSULTA</p>
            <h2 id="solution-title" className="mt-4 text-3xl font-black leading-[0.98] tracking-[-0.04em] text-white sm:text-5xl" style={{
            paddingLeft: "11px",
            paddingRight: "18px"
          }} data-id="element-113" data-mp="2idty3wgeqdes">AHORA TENÉS DÓNDE CONSULTAR.</h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-blue-100/80 sm:text-base" style={{
            paddingBottom: "0px",
            paddingLeft: "21px",
            paddingRight: "22px"
          }} data-id="element-114" data-mp="9vpswgbj2ke8">Tu biblioteca de instalaciones eléctricas, organizada para encontrar lo que necesitás.</p>
          </div>

          <div className="relative mx-auto mt-12 max-w-3xl space-y-0" data-id="element-115" data-mp="nwtuswitxanc">
            <div className="absolute bottom-10 left-[23px] top-10 w-px bg-[#F5C844]/75 sm:left-[35px]" aria-hidden="true" data-id="element-116" data-mp="sull5m3tsopf" />
            {solutionSteps.map((step, index) => <article key={step.number} data-reveal className={`technical-reveal technical-reveal-delay-${index + 1} relative grid grid-cols-[48px_1fr] gap-5 py-5 sm:grid-cols-[72px_1fr] sm:gap-7 sm:py-7 ${index > 0 ? 'border-t border-blue-200/15' : ''}`} style={{
            paddingTop: "0px",
            paddingBottom: "0px",
            paddingLeft: "18px"
          }} data-id="element-117" data-mp="eut1ubumparh" data-mpi={index}>
                <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-[#F5C844] bg-[#0B1F3B] text-xs font-black text-[#F5C844] sm:h-[72px] sm:w-[72px] sm:text-base" data-id="element-118" data-mp="2w22q5alevmh5">{step.number}</span>
                <div className="pt-1.5 sm:pt-3" data-id="element-119" data-mp="35zh4n4nry16t">
                  <div className="flex items-center gap-3" data-id="element-120" data-mp="312768zieqf6u">
                    <step.icon className="h-5 w-5 flex-shrink-0 text-[#F5C844]" aria-hidden="true" data-id="element-121" data-mp="2dcw4bepbmer4" />
                    <h3 className="text-sm font-black tracking-wide text-white sm:text-xl" data-id="element-122" data-mp="28dtbqtqj2101">{step.title}</h3>
                  </div>
                  <p className="mt-2 max-w-lg text-sm leading-relaxed text-blue-100/75 sm:text-base" data-id="element-123" data-mp="2n2z6a4ef731l">{step.description}</p>
                </div>
              </article>)}
          </div>

          <figure data-reveal className="technical-reveal technical-reveal-delay-3 relative mx-auto mt-10 w-full max-w-[620px] overflow-hidden sm:mt-12" data-id="element-124" data-mp="1um4wwiow8yfd">
            <img src="https://cdn.magicpatterns.com/uploads/qcDwYnMt6WN9QgH8AS6ckM/Biblioteca_Electrica_Siempre_a_Mano.webp" alt="Biblioteca de +100 Instalaciones Eléctricas Resueltas disponible desde la aplicación" className="block h-auto w-full" style={{
            height: "496px"
          }} data-id="element-125" data-mp="1pn1u74wdz4ak" />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[18%] bg-gradient-to-b from-transparent to-[#F4F7FA]" aria-hidden="true" data-id="element-126" data-mp="3arzxoo2980r" />
          </figure>
        </div>
      </div>
    </section>;
}